function brandInitializer() {

  return {
    getBrand() {
      return window.process && window.process.env ? window.process.env.WHITELABEL_BRAND : 'wealthbar';
    },
    getBrandFullName() {
      let fullName = 'CI Direct Investing';
      if (window.process && window.process.env) {
        fullName = window.process.env.WHITELABEL_FULL_NAME;
      }
      return fullName;
    },
    getLocalizedBrandFullNames() {
      let fullName = {
        en: 'CI Direct Investing',
        fr: 'Investissement direct CI',
      };
      if (window.process && window.process.env) {
        fullName = {
          en: window.process.env.WHITELABEL_FULL_NAME,
          fr: window.process.env.WHITELABEL_FULL_NAME_FR,
        }
      }
      return fullName;
    }
  };
}

angular.module('wbServices').service('brand', [brandInitializer]);

export default brandInitializer;
